<script-tag src="/assets/scripts/form-landing-tracking.js"></script-tag>
<header>
  <nav class="navbar is-light">
    <div class="container">
      <div class="navbar-brand">
        @if (brandService.logoSrc) {
          <img class="logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}}">
        }
      </div>

      @if (officeStatus && officeStatus.answer) {
        <div class="navbar-end">
          <p class="has-text-grey-dark is-size-6-mobile">or call for rates...</p>
          <p class="is-size-4 is-size-5-mobile">
            <a href="tel:{{officeStatus.phone}}" target="_blank">
              <i class="fas fa-phone"></i>
              {{ officeStatus.phonefancy }}
            </a>
          </p>
        </div>
      }
    </div>
  </nav>
</header>

<section class="section" id="one-to-one-consent">
  <div class="container">
    @if (! lead && ! loadErrorMessage) {
      <h1 class="title is-size-4 has-text-centered has-text-black">
        <i class="fas fa-spinner fa-pulse fa-fw"></i>
        Loading your information...
      </h1>
    }

    @if (loadErrorMessage) {
      <div class="notification is-danger" role="alert">
        {{ loadErrorMessage }}
      </div>
    }

    @if (lead) {
      <h1 class="title is-size-4 has-text-centered has-text-black">
        {{ lead.firstName }}, {{ msg }}
      </h1>
    }

    @if (lead) {
      <consent-form
        [lead]="lead"
        [encryptedLeadId] = "encryptedLeadId"
        [selectedEnabled] = "selectedEnabled"
        [availableSelected]="availableSelected$ | async">
        Loading your information...
      </consent-form>
    }
  </div>
</section>

@if (brandService.view !== 'mm') {
  <footer class="footer has-text-grey">
    <div class="container">
      <div class="columns">
        <div class="column">
          @if (brandService.logoSrc) {
            <img class="logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}}">
          }
        </div>
        <div class="column">
          @if (officeStatus && officeStatus.answer) {
            <p class="is-size-4 is-size-5-mobile">
              <a class="has-text-grey" href="tel:{{ officeStatus.phone }}" target="_blank">
                <span class="icon">
                  <i class="fas fa-phone"></i>
                </span>
                {{ officeStatus.phonefancy }}
              </a>
            </p>
          }
          <p>
            <span class="icon is-pulled-left">
              <i class="fas fa-map-marker is-size-4 is-size-5-mobile"></i>
            </span>
            2 Ponds Edge Drive
            <br>Chadds Ford, PA 19317
            </p>
            <p>
              <span class="icon is-pulled-left">
                <i class="fas fa-hashtag is-size-4 is-size-5-mobile"></i>
              </span>
              <span>
                NMLS #1154338. Go here for the FreeRateUpdate
                <a href="http://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1154338" target="_blank">NMLS Consumer Access Page.</a>
              </span>
            </p>
          </div>
          <div class="column">
            <p>
              <a href="http://latimesblogs.latimes.com/money_co/2010/03/mortgage-rates-remain-near-record-lows-for-modern-era.html" rel="nofollow"
                target="_blank">
                as seen on...
                <br>
                  <img src="https://www.freerateupdate.com/images/logo-la-times.png" alt="Los Angeles Times">
                </a>
              </p>
              <p>
                <a href="/contact" target="_blank">Contact Us</a> |
                <a href="/privacy" rel="nofollow" target="_blank">Privacy Policy</a>
                <a href="/glba" rel="nofollow" target="_blank">GLBA Policy</a>
                <li><a rel="nofollow" target="_blank" href="/cpra_policy">CPRA Policy</a></li>
              </p>
              <p>
                <a href="/terms" rel="nofollow" target="_blank">General Terms</a> |
                <a href="/landing/approved_lenders.php" target="_blank">Approved Lenders</a> |
                <a href="/licensing_disclosure" rel="nofollow" target="_blank">Licensing Disclosure</a> |
                <a href="/html-sitemap" target="_blank">Sitemap</a>
              </p>
            </div>
          </div>
          <p>
            FreeRateUpdate.com LLC is a Licensed Mortgage Broker, as required by law, with its main office located at 2 Ponds Edge Drive, Chadds Ford, PA 19317. NMLS Unique Identifier #1154338. &copy; FreeRateUpdate.com LLC 2008 - {{ currentYear }}.
            All Rights Reserved. This site is directed at, and made available to, persons in the continental U.S, and Hawaii only.
          </p>
        </div>
      </footer>
    }

    @if (brandService.view === 'mm') {
      <footer class="footer mm is-size-7 has-text-centered-touch">
        <nav class="navbar is-light">
          <div class="container">
            <div class="navbar-brand">
              @if (brandService.logoSrc) {
                <img class="logo" src="{{ brandService.logoSrc }}" alt="{{ brandService.domain }}">
              }
            </div>
            <div class="navbar-end">
              <a class="navbar-item has-text-grey-light" href="/contact" target="_blank">
                Contact Us
              </a>
              <a class="navbar-item has-text-grey-light" href="/privacy_policy.php" target="_blank">
                Privacy Policy
              </a>
              <a class="navbar-item has-text-grey-light" href="/terms" target="_blank">
                General Terms
              </a>
            </div>
          </div>
        </nav>
        <div class="container">
          <p class="copyright">
            {{ currentYear }} &copy; All Rights Reserved
          </p>
        </div>
      </footer>
    }
